module.exports = __webpack_public_path__ + "img/incognito.865cebc9.svg";